import { Pipe, PipeTransform } from '@angular/core';

import { userActiveProductIds } from '../constants/constants';
import { ShowAllProductsSelected } from '../models/show-all-products-selected.interface';

@Pipe({ name: 'hasUserEopProduct', standalone: true })
export class HasUserEopProductPipe implements PipeTransform {
  transform(
    section: string,
    areAllProductsSelected: ShowAllProductsSelected,
    userServiceUserData: any,
    productList: any,
    eopType
  ): boolean {
    if (areAllProductsSelected[section]) {
      return true;
    }
    const productIds = userActiveProductIds(section, userServiceUserData);
    for (const eopProduct of productList.eop[eopType]) {
      if (productIds.indexOf(eopProduct.id) >= 0) {
        return true;
      }
    }
    return false;
  }
}
